import { StateManager } from "./StateManager";
import { IStoreState } from "./StateStore";

export class TPStateManager extends StateManager<IStoreState> {
	
}